// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Fonts */
.text-display-xl-med {
  font-weight: 500;
  font-size: 64px;
  line-height: 105px;
  letter-spacing: 0;
}
.text-display-lg-med {
  font-weight: 500;
  font-size: 48px;
  line-height: 54px;
  letter-spacing: 0;
}
.text-display-lg-reg {
  font-weight: 400;
  font-size: 48px;
  line-height: 48px;
  letter-spacing: 0;
}
.text-display-md-med {
  font-weight: 500;
  font-size: 32px;
  line-height: 52px;
  letter-spacing: 0;
}
.text-display-md-reg {
  font-weight: 400;
  font-size: 31px;
  line-height: 32px;
  letter-spacing: 0;
}
.text-heading-lg-med {
  font-weight: 500;
  font-size: 28px;
  line-height: 46px;
  letter-spacing: 0;
}
.text-heading-md-med {
  font-weight: 500;
  font-size: 24px;
  line-height: 39px;
  letter-spacing: 0;
}
.text-title-xl-med {
  font-weight: 500;
  font-size: 22px;
  line-height: 26px;
  letter-spacing: 0;
}
.text-title-lg-med {
  font-weight: 500;
  font-size: 20px;
  line-height: 22px;
  letter-spacing: 0;
}
.text-title-md-med {
  font-weight: 500;
  font-size: 18px;
  line-height: 30px;
  letter-spacing: 0;
}
.text-title-s-med {
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
  letter-spacing: 0;
}
.text-title-xs-med {
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.01rem;
}
.text-body-lg-reg {
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  letter-spacing: 0;
}
.text-body-s-reg {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.01rem;
}
.text-body-xs-reg {
  font-weight: 400;
  font-size: 10px;
  line-height: 14px;
  letter-spacing: 0.01rem;
}
.text-label-input-reg {
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;
  letter-spacing: 0.005rem;
}
.text-label-lg-med {
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  letter-spacing: 0.005rem;
}
.text-label-md-med {
  font-weight: 500;
  font-size: 13px;
  line-height: 13px;
  letter-spacing: 0.005rem;
}
.text-label-md-reg {
  font-weight: 400;
  font-size: 13px;
  line-height: 13px;
  letter-spacing: 0.005rem;
}
.text-label-s-med {
  font-weight: 500;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: 0.005rem;
}
.text-label-s-reg {
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: 0.005rem;
}
.text-label-xs-reg {
  font-weight: 400;
  font-size: 11px;
  line-height: 11px;
  letter-spacing: 0.01rem;
}
.text-label-xxs-reg {
  font-weight: 400;
  font-size: 10px;
  line-height: 14px;
  letter-spacing: 0.01rem;
}
.text-button-md-med {
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: 0.01rem;
}
.text-button-xl-med {
  font-weight: 500;
  font-size: 15px;
  line-height: 15px;
  letter-spacing: 0.01rem;
}
.text-spacing-0 {
  letter-spacing: 0;
}
.text-card-s-med {
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.005rem;
}
.text-sidebar-header {
  font-weight: 500;
  font-size: 24px;
  line-height: 36px;
  letter-spacing: 0;
}
.text-table-timezone {
  font-weight: 400;
  font-size: 7px;
  line-height: 11px;
  letter-spacing: 0.005rem;
}
/* Colors */
.text-blue-dark {
  color: var(--blue-dark) !important;
}
.text-blue-100 {
  color: var(--blue-100) !important;
}
.text-blue-20 {
  color: var(--blue-20) !important;
}
.text-blue-80 {
  color: var(--blue-80) !important;
}
.text-blue-4 {
  color: var(--blue-4) !important;
}
.text-green-dark {
  color: var(--green-dark) !important;
}
.text-green-100 {
  color: var(--green-100) !important;
}
.text-green-20 {
  color: var(--green-20) !important;
}
.text-red-dark {
  color: var(--red-dark) !important;
}
.text-red-100 {
  color: var(--red-100) !important;
}
.text-red-20 {
  color: var(--red-20) !important;
}
.text-red-4 {
  color: var(--red-4) !important;
}
.text-butterscotch-dark {
  color: var(--butterscotch-dark) !important;
}
.text-butterscotch-100 {
  color: var(--butterscotch-100) !important;
}
.text-butterscotch-20 {
  color: var(--butterscotch-20) !important;
}
.text-green-4 {
  color: var(--green-4) !important;
}
.text-gray-100 {
  color: var(--gray-100) !important;
}
.text-gray-80 {
  color: var(--gray-80) !important;
}
.text-gray-60 {
  color: var(--gray-60) !important;
}
.text-gray-50 {
  color: var(--gray-50) !important;
}
.text-gray-40 {
  color: var(--gray-40) !important;
}
.text-gray-20 {
  color: var(--gray-20) !important;
}
.text-gray-10 {
  color: var(--gray-10) !important;
}
.text-gray-1 {
  color: var(--gray-1) !important;
}
.text-primary-white {
  color: var(--primary-white) !important;
}
.text-primary-black {
  color: var(--primary-black) !important;
}
.text-inherit {
  color: inherit !important;
}

.hover-text-blue-dark:hover {
  color: var(--blue-dark) !important;
}
.hover-text-blue-100:hover {
  color: var(--blue-100) !important;
}
.hover-text-blue-20:hover {
  color: var(--blue-20) !important;
}
.hover-text-blue-4:hover {
  color: var(--blue-4) !important;
}
.hover-text-green-dark:hover {
  color: var(--green-dark) !important;
}
.hover-text-green-100:hover {
  color: var(--green-100) !important;
}
.hover-text-green-20:hover {
  color: var(--green-20) !important;
}
.hover-text-red-dark:hover {
  color: var(--red-dark) !important;
}
.hover-text-red-100:hover {
  color: var(--red-100) !important;
}
.hover-text-red-20:hover {
  color: var(--red-20) !important;
}
.hover-text-red-4:hover {
  color: var(--red-4) !important;
}
.hover-text-butterscotch-dark:hover {
  color: var(--butterscotch-dark) !important;
}
.hover-text-butterscotch-100:hover {
  color: var(--butterscotch-100) !important;
}
.hover-text-butterscotch-20:hover {
  color: var(--butterscotch-20) !important;
}
.hover-text-green-4:hover {
  color: var(--green-4) !important;
}
.hover-text-gray-100:hover {
  color: var(--gray-100) !important;
}
.hover-text-gray-80:hover {
  color: var(--gray-80) !important;
}
.hover-text-gray-60:hover {
  color: var(--gray-60) !important;
}
.hover-text-gray-50:hover {
  color: var(--gray-50) !important;
}
.hover-text-gray-40:hover {
  color: var(--gray-40) !important;
}
.hover-text-gray-20:hover {
  color: var(--gray-20) !important;
}
.hover-text-gray-10:hover {
  color: var(--gray-10) !important;
}
.hover-text-gray-1:hover {
  color: var(--gray-1) !important;
}
.hover-text-primary-white:hover {
  color: var(--primary-white) !important;
}

.bg-blue-dark {
  background-color: var(--blue-dark) !important;
}
.bg-blue-100 {
  background-color: var(--blue-100) !important;
}
.bg-blue-20 {
  background-color: var(--blue-20) !important;
}
.bg-blue-4 {
  background-color: var(--blue-4) !important;
}
.bg-green-dark {
  background-color: var(--green-dark) !important;
}
.bg-green-100 {
  background-color: var(--green-100) !important;
}
.bg-green-20 {
  background-color: var(--green-20) !important;
}
.bg-red-dark {
  background-color: var(--red-dark) !important;
}
.bg-red-100 {
  background-color: var(--red-100) !important;
}
.bg-red-20 {
  background-color: var(--red-20) !important;
}
.bg-red-4 {
  background-color: var(--red-4) !important;
}
.bg-butterscotch-dark {
  background-color: var(--butterscotch-dark) !important;
}
.bg-butterscotch-100 {
  background-color: var(--butterscotch-100) !important;
}
.bg-butterscotch-20 {
  background-color: var(--butterscotch-20) !important;
}
.bg-green-4 {
  background-color: var(--green-4) !important;
}
.bg-gray-100 {
  background-color: var(--gray-100) !important;
}
.bg-gray-80 {
  background-color: var(--gray-80) !important;
}
.bg-gray-60 {
  background-color: var(--gray-60) !important;
}
.bg-gray-50 {
  background-color: var(--gray-50) !important;
}
.bg-gray-40 {
  background-color: var(--gray-40) !important;
}
.bg-gray-20 {
  background-color: var(--gray-20) !important;
}
.bg-gray-10 {
  background-color: var(--gray-10) !important;
}
.bg-gray-1 {
  background-color: var(--gray-1) !important;
}
.bg-primary-white {
  background-color: var(--primary-white) !important;
}
.bg-gray-4 {
  background-color: var(--gray-4) !important;
}
.bg-white-transparent {
  background-color: var(--primary-white-transparent) !important;
}

.hover-bg-blue-dark:hover {
  background-color: var(--blue-dark) !important;
}
.hover-bg-blue-100:hover {
  background-color: var(--blue-100) !important;
}
.hover-bg-blue-20:hover {
  background-color: var(--blue-20) !important;
}
.hover-bg-blue-4:hover {
  background-color: var(--blue-4) !important;
}
.hover-bg-green-dark:hover {
  background-color: var(--green-dark) !important;
}
.hover-bg-green-100:hover {
  background-color: var(--green-100) !important;
}
.hover-bg-green-20:hover {
  background-color: var(--green-20) !important;
}
.hover-bg-red-dark:hover {
  background-color: var(--red-dark) !important;
}
.hover-bg-red-100:hover {
  background-color: var(--red-100) !important;
}
.hover-bg-red-20:hover {
  background-color: var(--red-20) !important;
}
.hover-bg-red-4:hover {
  background-color: var(--red-4) !important;
}
.hover-bg-butterscotch-dark:hover {
  background-color: var(--butterscotch-dark) !important;
}
.hover-bg-butterscotch-100:hover {
  background-color: var(--butterscotch-100) !important;
}
.hover-bg-butterscotch-20:hover {
  background-color: var(--butterscotch-20) !important;
}
.hover-bg-green-4:hover {
  background-color: var(--green-4) !important;
}
.hover-bg-gray-100:hover {
  background-color: var(--gray-100) !important;
}
.hover-bg-gray-80:hover {
  background-color: var(--gray-80) !important;
}
.hover-bg-gray-60:hover {
  background-color: var(--gray-60) !important;
}
.hover-bg-gray-50:hover {
  background-color: var(--gray-50) !important;
}
.hover-bg-gray-40:hover {
  background-color: var(--gray-40) !important;
}
.hover-bg-gray-20:hover {
  background-color: var(--gray-20) !important;
}
.hover-bg-gray-10:hover {
  background-color: var(--gray-10) !important;
}
.hover-bg-gray-1:hover {
  background-color: var(--gray-1) !important;
}
.hover-bg-primary-white:hover {
  background-color: var(--primary-white) !important;
}

.border-blue-dark {
  border-color: var(--blue-dark) !important;
}
.border-blue-100 {
  border-color: var(--blue-100) !important;
}
.border-blue-20 {
  border-color: var(--blue-20) !important;
}
.border-blue-80 {
  border-color: var(--blue-80) !important;
}
.border-blue-4 {
  border-color: var(--blue-4) !important;
}
.border-green-dark {
  border-color: var(--green-dark) !important;
}
.border-green-100 {
  border-color: var(--green-100) !important;
}
.border-green-20 {
  border-color: var(--green-20) !important;
}
.border-red-dark {
  border-color: var(--red-dark) !important;
}
.border-red-100 {
  border-color: var(--red-100) !important;
}
.border-red-20 {
  border-color: var(--red-20) !important;
}
.border-red-4 {
  border-color: var(--red-4) !important;
}
.border-butterscotch-dark {
  border-color: var(--butterscotch-dark) !important;
}
.border-butterscotch-100 {
  border-color: var(--butterscotch-100) !important;
}
.border-butterscotch-20 {
  border-color: var(--butterscotch-20) !important;
}
.border-green-4 {
  border-color: var(--green-4) !important;
}
.border-gray-100 {
  border-color: var(--gray-100) !important;
}
.border-gray-80 {
  border-color: var(--gray-80) !important;
}
.border-gray-60 {
  border-color: var(--gray-60) !important;
}
.border-gray-50 {
  border-color: var(--gray-50) !important;
}
.border-gray-40 {
  border-color: var(--gray-40) !important;
}
.border-gray-20 {
  border-color: var(--gray-20) !important;
}
.border-gray-10 {
  border-color: var(--gray-10) !important;
}
.border-gray-1 {
  border-color: var(--gray-1) !important;
}
.border-primary-white {
  border-color: var(--primary-white) !important;
}

.hover-border-blue-dark:hover {
  border-color: var(--blue-dark) !important;
}
.hover-border-blue-100:hover {
  border-color: var(--blue-100) !important;
}
.hover-border-blue-20:hover {
  border-color: var(--blue-20) !important;
}
.hover-border-blue-4:hover {
  border-color: var(--blue-4) !important;
}
.hover-border-green-dark:hover {
  border-color: var(--green-dark) !important;
}
.hover-border-green-100:hover {
  border-color: var(--green-100) !important;
}
.hover-border-green-20:hover {
  border-color: var(--green-20) !important;
}
.hover-border-red-dark:hover {
  border-color: var(--red-dark) !important;
}
.hover-border-red-100:hover {
  border-color: var(--red-100) !important;
}
.hover-border-red-20:hover {
  border-color: var(--red-20) !important;
}
.hover-border-red-4:hover {
  border-color: var(--red-4) !important;
}
.hover-border-butterscotch-dark:hover {
  border-color: var(--butterscotch-dark) !important;
}
.hover-border-butterscotch-100:hover {
  border-color: var(--butterscotch-100) !important;
}
.hover-border-butterscotch-20:hover {
  border-color: var(--butterscotch-20) !important;
}
.hover-border-green-4:hover {
  border-color: var(--green-4) !important;
}
.hover-border-gray-100:hover {
  border-color: var(--gray-100) !important;
}
.hover-border-gray-80:hover {
  border-color: var(--gray-80) !important;
}
.hover-border-gray-60:hover {
  border-color: var(--gray-60) !important;
}
.hover-border-gray-50:hover {
  border-color: var(--gray-50) !important;
}
.hover-border-gray-40:hover {
  border-color: var(--gray-40) !important;
}
.hover-border-gray-20:hover {
  border-color: var(--gray-20) !important;
}
.hover-border-gray-10:hover {
  border-color: var(--gray-10) !important;
}
.hover-border-gray-1:hover {
  border-color: var(--gray-1) !important;
}
.hover-border-primary-white:hover {
  border-color: var(--primary-white) !important;
}

/* Shadows */
.shadow-level-1 {
  box-shadow: var(--shadow-level-1);
}
.shadow-level-2 {
  box-shadow: var(--shadow-level-2);
}
.shadow-level-3 {
  box-shadow: var(--shadow-level-3);
}
.shadow-white-2px {
  box-shadow: 0 0 0 2px var(--primary-white);
}

/* Striped background */
.bg-striped {
  background: repeating-linear-gradient(120deg, #f7faff, #f7faff 4px, #e1e3eb 4px, #e1e3eb 8px);
}

/* transition */
.transition-width {
  transition: width 0.5s;
}

/* break-word */
.overflow-wrap {
  overflow-wrap: anywhere;
}

/* allow labels with empty lines */
.white-space-pre-line {
  white-space: pre-line;
}

/* icon sizes for 24-outline icons with constant stroke-width 1.5px*/
.icon-60px {
  width: 60px;
  height: 60px;
  stroke-width: 0.75;
}
.icon-48px {
  width: 48px;
  height: 48px;
  stroke-width: 0.75;
}
.icon-40px {
  width: 40px;
  height: 40px;
  stroke-width: 0.9;
}
.icon-32px {
  width: 32px;
  height: 32px;
  stroke-width: 1.5;
}
.icon-28px-bold {
  width: 28px;
  height: 28px;
  stroke-width: 2;
}
.icon-28px {
  width: 28px;
  height: 28px;
  stroke-width: 1.5;
}
.icon-24px {
  width: 24px;
  height: 24px;
  stroke-width: 1.5;
}
.icon-20px {
  width: 20px;
  height: 20px;
  stroke-width: 1.8;
}
.icon-18px {
  width: 18px;
  height: 18px;
  stroke-width: 2;
}
.icon-16px {
  width: 16px;
  height: 16px;
  stroke-width: 2;
}
.icon-14px {
  width: 14px;
  height: 14px;
  stroke-width: 2.5;
}
.icon-12px {
  width: 12px;
  height: 12px;
  stroke-width: 2.5;
}
.icon-10px {
  width: 10px;
  height: 10px;
  stroke-width: 3;
}
.icon-8px {
  width: 8px;
  height: 8px;
  stroke-width: 3;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/css/sumoUtils.css"],"names":[],"mappings":"AAAA,UAAU;AACV;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,wBAAwB;AAC1B;AACA,WAAW;AACX;EACE,kCAAkC;AACpC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;AACpC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,sCAAsC;AACxC;;AAEA;EACE,6CAA6C;AAC/C;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,8CAA8C;AAChD;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,qDAAqD;AACvD;AACA;EACE,oDAAoD;AACtD;AACA;EACE,mDAAmD;AACrD;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,iDAAiD;AACnD;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6CAA6C;AAC/C;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,8CAA8C;AAChD;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,qDAAqD;AACvD;AACA;EACE,oDAAoD;AACtD;AACA;EACE,mDAAmD;AACrD;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,iDAAiD;AACnD;;AAEA;EACE,yCAAyC;AAC3C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,uCAAuC;AACzC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,uCAAuC;AACzC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,iDAAiD;AACnD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,uCAAuC;AACzC;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,uCAAuC;AACzC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,6CAA6C;AAC/C;;AAEA;EACE,yCAAyC;AAC3C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,uCAAuC;AACzC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,uCAAuC;AACzC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,iDAAiD;AACnD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,uCAAuC;AACzC;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,uCAAuC;AACzC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,6CAA6C;AAC/C;;AAEA,YAAY;AACZ;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,0CAA0C;AAC5C;;AAEA,uBAAuB;AACvB;EACE,6FAA6F;AAC/F;;AAEA,eAAe;AACf;EACE,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE,uBAAuB;AACzB;;AAEA,kCAAkC;AAClC;EACE,qBAAqB;AACvB;;AAEA,oEAAoE;AACpE;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,UAAU;EACV,WAAW;EACX,eAAe;AACjB","sourcesContent":["/* Fonts */\n.text-display-xl-med {\n  font-weight: 500;\n  font-size: 64px;\n  line-height: 105px;\n  letter-spacing: 0;\n}\n.text-display-lg-med {\n  font-weight: 500;\n  font-size: 48px;\n  line-height: 54px;\n  letter-spacing: 0;\n}\n.text-display-lg-reg {\n  font-weight: 400;\n  font-size: 48px;\n  line-height: 48px;\n  letter-spacing: 0;\n}\n.text-display-md-med {\n  font-weight: 500;\n  font-size: 32px;\n  line-height: 52px;\n  letter-spacing: 0;\n}\n.text-display-md-reg {\n  font-weight: 400;\n  font-size: 31px;\n  line-height: 32px;\n  letter-spacing: 0;\n}\n.text-heading-lg-med {\n  font-weight: 500;\n  font-size: 28px;\n  line-height: 46px;\n  letter-spacing: 0;\n}\n.text-heading-md-med {\n  font-weight: 500;\n  font-size: 24px;\n  line-height: 39px;\n  letter-spacing: 0;\n}\n.text-title-xl-med {\n  font-weight: 500;\n  font-size: 22px;\n  line-height: 26px;\n  letter-spacing: 0;\n}\n.text-title-lg-med {\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 22px;\n  letter-spacing: 0;\n}\n.text-title-md-med {\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 30px;\n  letter-spacing: 0;\n}\n.text-title-s-med {\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 26px;\n  letter-spacing: 0;\n}\n.text-title-xs-med {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 16px;\n  letter-spacing: 0.01rem;\n}\n.text-body-lg-reg {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 19px;\n  letter-spacing: 0;\n}\n.text-body-s-reg {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n  letter-spacing: 0.01rem;\n}\n.text-body-xs-reg {\n  font-weight: 400;\n  font-size: 10px;\n  line-height: 14px;\n  letter-spacing: 0.01rem;\n}\n.text-label-input-reg {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 14px;\n  letter-spacing: 0.005rem;\n}\n.text-label-lg-med {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 14px;\n  letter-spacing: 0.005rem;\n}\n.text-label-md-med {\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 13px;\n  letter-spacing: 0.005rem;\n}\n.text-label-md-reg {\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 13px;\n  letter-spacing: 0.005rem;\n}\n.text-label-s-med {\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 12px;\n  letter-spacing: 0.005rem;\n}\n.text-label-s-reg {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 12px;\n  letter-spacing: 0.005rem;\n}\n.text-label-xs-reg {\n  font-weight: 400;\n  font-size: 11px;\n  line-height: 11px;\n  letter-spacing: 0.01rem;\n}\n.text-label-xxs-reg {\n  font-weight: 400;\n  font-size: 10px;\n  line-height: 14px;\n  letter-spacing: 0.01rem;\n}\n.text-button-md-med {\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 18px;\n  letter-spacing: 0.01rem;\n}\n.text-button-xl-med {\n  font-weight: 500;\n  font-size: 15px;\n  line-height: 15px;\n  letter-spacing: 0.01rem;\n}\n.text-spacing-0 {\n  letter-spacing: 0;\n}\n.text-card-s-med {\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 18px;\n  letter-spacing: 0.005rem;\n}\n.text-sidebar-header {\n  font-weight: 500;\n  font-size: 24px;\n  line-height: 36px;\n  letter-spacing: 0;\n}\n.text-table-timezone {\n  font-weight: 400;\n  font-size: 7px;\n  line-height: 11px;\n  letter-spacing: 0.005rem;\n}\n/* Colors */\n.text-blue-dark {\n  color: var(--blue-dark) !important;\n}\n.text-blue-100 {\n  color: var(--blue-100) !important;\n}\n.text-blue-20 {\n  color: var(--blue-20) !important;\n}\n.text-blue-80 {\n  color: var(--blue-80) !important;\n}\n.text-blue-4 {\n  color: var(--blue-4) !important;\n}\n.text-green-dark {\n  color: var(--green-dark) !important;\n}\n.text-green-100 {\n  color: var(--green-100) !important;\n}\n.text-green-20 {\n  color: var(--green-20) !important;\n}\n.text-red-dark {\n  color: var(--red-dark) !important;\n}\n.text-red-100 {\n  color: var(--red-100) !important;\n}\n.text-red-20 {\n  color: var(--red-20) !important;\n}\n.text-red-4 {\n  color: var(--red-4) !important;\n}\n.text-butterscotch-dark {\n  color: var(--butterscotch-dark) !important;\n}\n.text-butterscotch-100 {\n  color: var(--butterscotch-100) !important;\n}\n.text-butterscotch-20 {\n  color: var(--butterscotch-20) !important;\n}\n.text-green-4 {\n  color: var(--green-4) !important;\n}\n.text-gray-100 {\n  color: var(--gray-100) !important;\n}\n.text-gray-80 {\n  color: var(--gray-80) !important;\n}\n.text-gray-60 {\n  color: var(--gray-60) !important;\n}\n.text-gray-50 {\n  color: var(--gray-50) !important;\n}\n.text-gray-40 {\n  color: var(--gray-40) !important;\n}\n.text-gray-20 {\n  color: var(--gray-20) !important;\n}\n.text-gray-10 {\n  color: var(--gray-10) !important;\n}\n.text-gray-1 {\n  color: var(--gray-1) !important;\n}\n.text-primary-white {\n  color: var(--primary-white) !important;\n}\n.text-primary-black {\n  color: var(--primary-black) !important;\n}\n.text-inherit {\n  color: inherit !important;\n}\n\n.hover-text-blue-dark:hover {\n  color: var(--blue-dark) !important;\n}\n.hover-text-blue-100:hover {\n  color: var(--blue-100) !important;\n}\n.hover-text-blue-20:hover {\n  color: var(--blue-20) !important;\n}\n.hover-text-blue-4:hover {\n  color: var(--blue-4) !important;\n}\n.hover-text-green-dark:hover {\n  color: var(--green-dark) !important;\n}\n.hover-text-green-100:hover {\n  color: var(--green-100) !important;\n}\n.hover-text-green-20:hover {\n  color: var(--green-20) !important;\n}\n.hover-text-red-dark:hover {\n  color: var(--red-dark) !important;\n}\n.hover-text-red-100:hover {\n  color: var(--red-100) !important;\n}\n.hover-text-red-20:hover {\n  color: var(--red-20) !important;\n}\n.hover-text-red-4:hover {\n  color: var(--red-4) !important;\n}\n.hover-text-butterscotch-dark:hover {\n  color: var(--butterscotch-dark) !important;\n}\n.hover-text-butterscotch-100:hover {\n  color: var(--butterscotch-100) !important;\n}\n.hover-text-butterscotch-20:hover {\n  color: var(--butterscotch-20) !important;\n}\n.hover-text-green-4:hover {\n  color: var(--green-4) !important;\n}\n.hover-text-gray-100:hover {\n  color: var(--gray-100) !important;\n}\n.hover-text-gray-80:hover {\n  color: var(--gray-80) !important;\n}\n.hover-text-gray-60:hover {\n  color: var(--gray-60) !important;\n}\n.hover-text-gray-50:hover {\n  color: var(--gray-50) !important;\n}\n.hover-text-gray-40:hover {\n  color: var(--gray-40) !important;\n}\n.hover-text-gray-20:hover {\n  color: var(--gray-20) !important;\n}\n.hover-text-gray-10:hover {\n  color: var(--gray-10) !important;\n}\n.hover-text-gray-1:hover {\n  color: var(--gray-1) !important;\n}\n.hover-text-primary-white:hover {\n  color: var(--primary-white) !important;\n}\n\n.bg-blue-dark {\n  background-color: var(--blue-dark) !important;\n}\n.bg-blue-100 {\n  background-color: var(--blue-100) !important;\n}\n.bg-blue-20 {\n  background-color: var(--blue-20) !important;\n}\n.bg-blue-4 {\n  background-color: var(--blue-4) !important;\n}\n.bg-green-dark {\n  background-color: var(--green-dark) !important;\n}\n.bg-green-100 {\n  background-color: var(--green-100) !important;\n}\n.bg-green-20 {\n  background-color: var(--green-20) !important;\n}\n.bg-red-dark {\n  background-color: var(--red-dark) !important;\n}\n.bg-red-100 {\n  background-color: var(--red-100) !important;\n}\n.bg-red-20 {\n  background-color: var(--red-20) !important;\n}\n.bg-red-4 {\n  background-color: var(--red-4) !important;\n}\n.bg-butterscotch-dark {\n  background-color: var(--butterscotch-dark) !important;\n}\n.bg-butterscotch-100 {\n  background-color: var(--butterscotch-100) !important;\n}\n.bg-butterscotch-20 {\n  background-color: var(--butterscotch-20) !important;\n}\n.bg-green-4 {\n  background-color: var(--green-4) !important;\n}\n.bg-gray-100 {\n  background-color: var(--gray-100) !important;\n}\n.bg-gray-80 {\n  background-color: var(--gray-80) !important;\n}\n.bg-gray-60 {\n  background-color: var(--gray-60) !important;\n}\n.bg-gray-50 {\n  background-color: var(--gray-50) !important;\n}\n.bg-gray-40 {\n  background-color: var(--gray-40) !important;\n}\n.bg-gray-20 {\n  background-color: var(--gray-20) !important;\n}\n.bg-gray-10 {\n  background-color: var(--gray-10) !important;\n}\n.bg-gray-1 {\n  background-color: var(--gray-1) !important;\n}\n.bg-primary-white {\n  background-color: var(--primary-white) !important;\n}\n.bg-gray-4 {\n  background-color: var(--gray-4) !important;\n}\n.bg-white-transparent {\n  background-color: var(--primary-white-transparent) !important;\n}\n\n.hover-bg-blue-dark:hover {\n  background-color: var(--blue-dark) !important;\n}\n.hover-bg-blue-100:hover {\n  background-color: var(--blue-100) !important;\n}\n.hover-bg-blue-20:hover {\n  background-color: var(--blue-20) !important;\n}\n.hover-bg-blue-4:hover {\n  background-color: var(--blue-4) !important;\n}\n.hover-bg-green-dark:hover {\n  background-color: var(--green-dark) !important;\n}\n.hover-bg-green-100:hover {\n  background-color: var(--green-100) !important;\n}\n.hover-bg-green-20:hover {\n  background-color: var(--green-20) !important;\n}\n.hover-bg-red-dark:hover {\n  background-color: var(--red-dark) !important;\n}\n.hover-bg-red-100:hover {\n  background-color: var(--red-100) !important;\n}\n.hover-bg-red-20:hover {\n  background-color: var(--red-20) !important;\n}\n.hover-bg-red-4:hover {\n  background-color: var(--red-4) !important;\n}\n.hover-bg-butterscotch-dark:hover {\n  background-color: var(--butterscotch-dark) !important;\n}\n.hover-bg-butterscotch-100:hover {\n  background-color: var(--butterscotch-100) !important;\n}\n.hover-bg-butterscotch-20:hover {\n  background-color: var(--butterscotch-20) !important;\n}\n.hover-bg-green-4:hover {\n  background-color: var(--green-4) !important;\n}\n.hover-bg-gray-100:hover {\n  background-color: var(--gray-100) !important;\n}\n.hover-bg-gray-80:hover {\n  background-color: var(--gray-80) !important;\n}\n.hover-bg-gray-60:hover {\n  background-color: var(--gray-60) !important;\n}\n.hover-bg-gray-50:hover {\n  background-color: var(--gray-50) !important;\n}\n.hover-bg-gray-40:hover {\n  background-color: var(--gray-40) !important;\n}\n.hover-bg-gray-20:hover {\n  background-color: var(--gray-20) !important;\n}\n.hover-bg-gray-10:hover {\n  background-color: var(--gray-10) !important;\n}\n.hover-bg-gray-1:hover {\n  background-color: var(--gray-1) !important;\n}\n.hover-bg-primary-white:hover {\n  background-color: var(--primary-white) !important;\n}\n\n.border-blue-dark {\n  border-color: var(--blue-dark) !important;\n}\n.border-blue-100 {\n  border-color: var(--blue-100) !important;\n}\n.border-blue-20 {\n  border-color: var(--blue-20) !important;\n}\n.border-blue-80 {\n  border-color: var(--blue-80) !important;\n}\n.border-blue-4 {\n  border-color: var(--blue-4) !important;\n}\n.border-green-dark {\n  border-color: var(--green-dark) !important;\n}\n.border-green-100 {\n  border-color: var(--green-100) !important;\n}\n.border-green-20 {\n  border-color: var(--green-20) !important;\n}\n.border-red-dark {\n  border-color: var(--red-dark) !important;\n}\n.border-red-100 {\n  border-color: var(--red-100) !important;\n}\n.border-red-20 {\n  border-color: var(--red-20) !important;\n}\n.border-red-4 {\n  border-color: var(--red-4) !important;\n}\n.border-butterscotch-dark {\n  border-color: var(--butterscotch-dark) !important;\n}\n.border-butterscotch-100 {\n  border-color: var(--butterscotch-100) !important;\n}\n.border-butterscotch-20 {\n  border-color: var(--butterscotch-20) !important;\n}\n.border-green-4 {\n  border-color: var(--green-4) !important;\n}\n.border-gray-100 {\n  border-color: var(--gray-100) !important;\n}\n.border-gray-80 {\n  border-color: var(--gray-80) !important;\n}\n.border-gray-60 {\n  border-color: var(--gray-60) !important;\n}\n.border-gray-50 {\n  border-color: var(--gray-50) !important;\n}\n.border-gray-40 {\n  border-color: var(--gray-40) !important;\n}\n.border-gray-20 {\n  border-color: var(--gray-20) !important;\n}\n.border-gray-10 {\n  border-color: var(--gray-10) !important;\n}\n.border-gray-1 {\n  border-color: var(--gray-1) !important;\n}\n.border-primary-white {\n  border-color: var(--primary-white) !important;\n}\n\n.hover-border-blue-dark:hover {\n  border-color: var(--blue-dark) !important;\n}\n.hover-border-blue-100:hover {\n  border-color: var(--blue-100) !important;\n}\n.hover-border-blue-20:hover {\n  border-color: var(--blue-20) !important;\n}\n.hover-border-blue-4:hover {\n  border-color: var(--blue-4) !important;\n}\n.hover-border-green-dark:hover {\n  border-color: var(--green-dark) !important;\n}\n.hover-border-green-100:hover {\n  border-color: var(--green-100) !important;\n}\n.hover-border-green-20:hover {\n  border-color: var(--green-20) !important;\n}\n.hover-border-red-dark:hover {\n  border-color: var(--red-dark) !important;\n}\n.hover-border-red-100:hover {\n  border-color: var(--red-100) !important;\n}\n.hover-border-red-20:hover {\n  border-color: var(--red-20) !important;\n}\n.hover-border-red-4:hover {\n  border-color: var(--red-4) !important;\n}\n.hover-border-butterscotch-dark:hover {\n  border-color: var(--butterscotch-dark) !important;\n}\n.hover-border-butterscotch-100:hover {\n  border-color: var(--butterscotch-100) !important;\n}\n.hover-border-butterscotch-20:hover {\n  border-color: var(--butterscotch-20) !important;\n}\n.hover-border-green-4:hover {\n  border-color: var(--green-4) !important;\n}\n.hover-border-gray-100:hover {\n  border-color: var(--gray-100) !important;\n}\n.hover-border-gray-80:hover {\n  border-color: var(--gray-80) !important;\n}\n.hover-border-gray-60:hover {\n  border-color: var(--gray-60) !important;\n}\n.hover-border-gray-50:hover {\n  border-color: var(--gray-50) !important;\n}\n.hover-border-gray-40:hover {\n  border-color: var(--gray-40) !important;\n}\n.hover-border-gray-20:hover {\n  border-color: var(--gray-20) !important;\n}\n.hover-border-gray-10:hover {\n  border-color: var(--gray-10) !important;\n}\n.hover-border-gray-1:hover {\n  border-color: var(--gray-1) !important;\n}\n.hover-border-primary-white:hover {\n  border-color: var(--primary-white) !important;\n}\n\n/* Shadows */\n.shadow-level-1 {\n  box-shadow: var(--shadow-level-1);\n}\n.shadow-level-2 {\n  box-shadow: var(--shadow-level-2);\n}\n.shadow-level-3 {\n  box-shadow: var(--shadow-level-3);\n}\n.shadow-white-2px {\n  box-shadow: 0 0 0 2px var(--primary-white);\n}\n\n/* Striped background */\n.bg-striped {\n  background: repeating-linear-gradient(120deg, #f7faff, #f7faff 4px, #e1e3eb 4px, #e1e3eb 8px);\n}\n\n/* transition */\n.transition-width {\n  transition: width 0.5s;\n}\n\n/* break-word */\n.overflow-wrap {\n  overflow-wrap: anywhere;\n}\n\n/* allow labels with empty lines */\n.white-space-pre-line {\n  white-space: pre-line;\n}\n\n/* icon sizes for 24-outline icons with constant stroke-width 1.5px*/\n.icon-60px {\n  width: 60px;\n  height: 60px;\n  stroke-width: 0.75;\n}\n.icon-48px {\n  width: 48px;\n  height: 48px;\n  stroke-width: 0.75;\n}\n.icon-40px {\n  width: 40px;\n  height: 40px;\n  stroke-width: 0.9;\n}\n.icon-32px {\n  width: 32px;\n  height: 32px;\n  stroke-width: 1.5;\n}\n.icon-28px-bold {\n  width: 28px;\n  height: 28px;\n  stroke-width: 2;\n}\n.icon-28px {\n  width: 28px;\n  height: 28px;\n  stroke-width: 1.5;\n}\n.icon-24px {\n  width: 24px;\n  height: 24px;\n  stroke-width: 1.5;\n}\n.icon-20px {\n  width: 20px;\n  height: 20px;\n  stroke-width: 1.8;\n}\n.icon-18px {\n  width: 18px;\n  height: 18px;\n  stroke-width: 2;\n}\n.icon-16px {\n  width: 16px;\n  height: 16px;\n  stroke-width: 2;\n}\n.icon-14px {\n  width: 14px;\n  height: 14px;\n  stroke-width: 2.5;\n}\n.icon-12px {\n  width: 12px;\n  height: 12px;\n  stroke-width: 2.5;\n}\n.icon-10px {\n  width: 10px;\n  height: 10px;\n  stroke-width: 3;\n}\n.icon-8px {\n  width: 8px;\n  height: 8px;\n  stroke-width: 3;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
